/* Produktseitige Anker: Sprung auf Autorenfoto und alle echten Bewertungen. */
(() => {
  if (window.sfProductNavFixInstalled) return;
  window.sfProductNavFixInstalled = true;
  const apply = (animated = false) => {
    const width = window.innerWidth;
    // Covers iPad portrait/landscape including the 12.9-inch 1366px layout.
    // Keep desktop navigation outside this range unchanged.
    if (width > 1366) return;
    const hash = window.location.hash;
    if (hash !== '#ueber-mich' && hash !== '#social') return;
    const section = document.querySelector('#ueber-mich.sf-author');
    if (!section) return;
    const mobile = width < 750;
    const header = document.querySelector('[data-sf-header]');
    const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    const bar = document.querySelector('[data-sf-buybar]:not([hidden])');
    const buyBarHeight = bar?.getBoundingClientRect().height || 0;

    const pageWrapper = document.querySelector('.page-wrapper');
    const wrapperScroll = Boolean(pageWrapper
      && pageWrapper.scrollHeight > pageWrapper.clientHeight + 3
      && /^(auto|scroll)$/.test(window.getComputedStyle(pageWrapper).overflowY));
    const scrollHost = wrapperScroll ? pageWrapper : window;
    const rootTop = wrapperScroll ? pageWrapper.getBoundingClientRect().top : 0;
    const scrollTop = wrapperScroll ? pageWrapper.scrollTop : window.scrollY;
    const absoluteTop = el => el.getBoundingClientRect().top - rootTop + scrollTop;
    const behavior = animated && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant';

    if (hash === '#ueber-mich') {
      const photo = section.querySelector('.sf-author-portrait');
      const heading = section.querySelector('h2');
      const eyebrow = section.querySelector('.sf-eyebrow');
      if (!photo) return;
      let targetY;
      if (mobile) {
        // Keep the headline readable ABOVE the sticky buy bar and most of the portrait visible.
        const stickyTop = bar && !bar.hidden ? bar.getBoundingClientRect().top : viewportHeight - 82;
        const visibleBottom = stickyTop > headerBottom + 100 && stickyTop <= viewportHeight
          ? stickyTop : viewportHeight - buyBarHeight;
        const headingBottom = heading ? absoluteTop(heading) + heading.getBoundingClientRect().height : absoluteTop(photo) + photo.getBoundingClientRect().height;
        const photoTop = absoluteTop(photo);
        const headingAlignedY = headingBottom - (visibleBottom - 45);
        // Limit the crop to about 28 CSS pixels, even on smaller iPhones.
        const maxPhotoCropY = photoTop - (headerBottom - 28);
        targetY = Math.min(headingAlignedY,maxPhotoCropY);
      } else {
        // iPad: preserve the small 'DER MENSCH HINTER DEM BUCH' line beneath the header.
        const label = eyebrow || heading || photo;
        targetY = absoluteTop(label) - (headerBottom + 38);
      }
      scrollHost.scrollTo({top:Math.max(0,Math.round(targetY)),behavior});
    } else {
      const links = section.querySelector('#social.sf-author-links');
      const firstIcon = links?.querySelector('a') || links;
      if (!firstIcon) return;
      const desiredY = Math.round(viewportHeight * (mobile ? .55 : .59));
      scrollHost.scrollTo({top:Math.max(0,Math.round(absoluteTop(firstIcon) - desiredY)),behavior});
    }
  };
    if (new URLSearchParams(window.location.search).get('bewertungen') === '1') {
      const openReviews = () => {
        const opener = document.querySelector('[data-sf-gallery-reviews-open]');
        if (opener && !document.querySelector('#sf-book-zoom-dialog[open]')) opener.click();
      };
      window.addEventListener('load', () => requestAnimationFrame(openReviews), {once:true});
    }
  let aboutNavigationUntil = 0;
  let allowAutomaticCorrection = true;
  const cancelAutomaticCorrection = () => { allowAutomaticCorrection = false; };
  document.addEventListener('wheel',cancelAutomaticCorrection,{passive:true});
  document.addEventListener('touchmove',cancelAutomaticCorrection,{passive:true});
  document.addEventListener('keydown',event=>{
    if (event.target?.closest?.('input,textarea,select,[contenteditable="true"]')) return;
    if (['ArrowUp','ArrowDown','PageUp','PageDown','Home','End',' '].includes(event.key)) cancelAutomaticCorrection();
  });
  const schedule = (animated = false) => {
    if (!allowAutomaticCorrection) return;
    // Do not let an image/font/pageshow correction interrupt a menu click in progress.
    if (!animated && location.hash === '#ueber-mich' && performance.now() < aboutNavigationUntil) return;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (allowAutomaticCorrection) apply(animated);
    }));
  };
  const authorImage = document.querySelector('#ueber-mich.sf-author .sf-author-portrait img');
  if (authorImage && !authorImage.complete) authorImage.addEventListener('load',()=>schedule(false),{once:true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>schedule(false),{once:true});
  else schedule();
  window.addEventListener('hashchange',()=>{ allowAutomaticCorrection = true; schedule(false); });
  document.addEventListener('sf:author-nav-target',event=>{
    allowAutomaticCorrection = true;
    if (location.hash === '#ueber-mich') aboutNavigationUntil = performance.now() + 1100;
    schedule(event.detail?.animated === true);
  });
  document.fonts?.ready?.then(() => { if (location.hash === '#ueber-mich' || location.hash === '#social') schedule(); });
  window.addEventListener('load',()=>schedule(false),{once:true});
  window.addEventListener('pageshow',()=>schedule(false));
  // A link opened from the homepage can be scrolled to its native hash before
  // Shopify's image, font and section dimensions settle. Correct only that entry
  // transition; preserve the already-approved positions in apply().
  const entryHash = location.hash;
  if (entryHash === '#ueber-mich' || entryHash === '#social') {
    let cancelled = false;
    let lastGeometry = '';
    let stableChecks = 0;
    const correctEntry = () => {
      if (cancelled || !allowAutomaticCorrection || location.hash !== entryHash) return;
      const author = document.querySelector('#ueber-mich.sf-author');
      if (!author) return;
      const photo = author.querySelector('.sf-author-portrait');
      const links = author.querySelector('#social.sf-author-links');
      const heading = author.querySelector('h2');
      if (!photo || !links) return;
      const geometry = [
        Math.round(photo.getBoundingClientRect().height),
        Math.round(links.getBoundingClientRect().top - photo.getBoundingClientRect().top),
        heading ? Math.round(heading.getBoundingClientRect().top - photo.getBoundingClientRect().top) : 0,
        document.documentElement.scrollHeight
      ].join(':');
      if (geometry === lastGeometry) stableChecks++;
      else stableChecks = 0;
      lastGeometry = geometry;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (!cancelled && allowAutomaticCorrection && location.hash === entryHash) apply(false);
      }));
    };
    // Cancel automatic correction as soon as the visitor chooses another
    // position or explicitly clicks the menu again.
    const cancelEntry = () => { cancelled = true; if (observer) observer.disconnect(); };
    document.addEventListener('touchstart',cancelEntry,{once:true,passive:true});
    document.addEventListener('wheel',cancelEntry,{once:true,passive:true});
    document.addEventListener('sf:author-nav-target',cancelEntry,{once:true});
    const author = document.querySelector('#ueber-mich.sf-author');
    const observer = typeof ResizeObserver !== 'undefined' && author
      ? new ResizeObserver(correctEntry) : null;
    if (observer && author) {
      observer.observe(author);
      const photo = author.querySelector('.sf-author-portrait');
      if (photo) observer.observe(photo);
    }
    const image = author?.querySelector('.sf-author-portrait img');
    if (image && !image.complete) image.addEventListener('load',correctEntry,{once:true});
    if (image?.decode) image.decode().then(correctEntry).catch(() => {});
    document.fonts?.ready?.then(correctEntry);
    window.addEventListener('load',correctEntry,{once:true});
    window.addEventListener('pageshow',correctEntry,{once:true});
    [0,100,320,750,1250,1900].forEach(delay => setTimeout(correctEntry,delay));
    setTimeout(() => { if (observer) observer.disconnect(); cancelled = true; },2300);
  }
  document.addEventListener('click', e => {
    const link = e.target.closest('a[href]');
    if (!link) return;
    const dest = new URL(link.href, window.location.href);
    if (dest.pathname !== window.location.pathname) return;
    if (dest.hash === '#ueber-mich' || dest.hash === '#social') {
      const menu = link.closest('details.sf-mobile-menu');
      if (menu) menu.open = false;
      // Header navigation dispatches the single author-target event; don't scroll twice.
    }
  });
})();

